import { useState } from 'react';
import { LockIcon } from '@/assets/icons/LockIcon';
import { Button } from '@/components/ui/Button';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { ProfileCard } from '@/components/common/ProfileCard';
import { ReplaceEmailDialog } from './ReplaceEmailDialog';

const P = UI_STRINGS.PROFILE;

interface EmailCardProps {
  email: string;
  /**
   * Whether this person may replace their email (FR-14, MYN-76): an
   * Individual who has not used the one-time replacement yet. Entity members'
   * emails are tied to their membership, so they never get the action.
   */
  canReplace: boolean;
}

/**
 * Email card (FR-179, client-approved Option D): the locked email, with the
 * one-time Update Email action in the header and its note underneath.
 */
export function EmailCard({ email, canReplace }: EmailCardProps) {
  const [isReplaceOpen, setIsReplaceOpen] = useState(false);
  const action = canReplace ? (
    <Button variant="outline-md" onClick={() => setIsReplaceOpen(true)}>
      {P.REPLACE_EMAIL}
    </Button>
  ) : undefined;
  const title = (
    <>
      {P.FIELD_EMAIL}
      <LockIcon size={16} className="text-slate" />
    </>
  );

  return (
    <ProfileCard title={title} action={action}>
      <p className="text-input text-navy mb-2.5 font-medium break-all">{email}</p>
      {canReplace && (
        <p className="text-subtext text-[0.8125rem] leading-5">{P.EMAIL_LOCKED_HINT_INDIVIDUAL}</p>
      )}
      {canReplace && <ReplaceEmailDialog open={isReplaceOpen} onOpenChange={setIsReplaceOpen} />}
    </ProfileCard>
  );
}
